module.exports = __webpack_public_path__ + "static/img/info.dd81d224.svg";